import { Formik } from 'formik';
import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { stepInfoFulfilled } from '../../../actions/damageReportActions';
import { IDamageReportReducer } from '../../../reducers/damageReportReducer';
import { RootState } from '../../../store';
import { WizardPageProps } from '../../wizard/wizard';
import { stepInfoSchema } from './stepInfo.schema';
import * as StyledStepInfo from './stepInfo.styles';
import StepInfoForm from './stepInfoForm';

interface Props extends WizardPageProps {}
const StepInfo: FC<Props> = ({ onSubmit, onPrevious }) => {
	const dispatch = useDispatch<any>();
	const damageReportReducer: IDamageReportReducer = useSelector((store: RootState) => store.damageReportReducer);
	const { stepInfo } = damageReportReducer;

	const onStepInfoSubmit = values => {
		dispatch(stepInfoFulfilled(values));
		onSubmit(values);
	};

	const onStepInfoPrevious = values => {
		dispatch(stepInfoFulfilled(values));
		onPrevious();
	};

	return (
		<StyledStepInfo.Wrapper>
			<Formik
				initialValues={stepInfo}
				enableReinitialize
				validationSchema={stepInfoSchema}
				onSubmit={onStepInfoSubmit}>
				{({ values, setFieldTouched, setFieldValue, isValid, isSubmitting, errors }) => (
					<StepInfoForm
						values={values}
						errors={errors}
						onPrevious={v => onStepInfoPrevious(v)}
						setFieldTouched={setFieldTouched}
						setFieldValue={setFieldValue}
						isSubmitting={isSubmitting}
						isValid={isValid}
					/>
				)}
			</Formik>
		</StyledStepInfo.Wrapper>
	);
};

export default StepInfo;
